export const SA_SUBURBS = [
    // Cape Town - City Bowl & Atlantic Seaboard
    "Camps Bay", "Sea Point", "Green Point", "Bantry Bay", "Clifton", "Fresnaye", "Mouille Point", "Three Anchor Bay",
    "Gardens", "Oranjezicht", "Vredehoek", "Tamboerskloof", "Higgovale", "Walmer Estate", "Woodstock", "Salt River",
    // Cape Town - Southern Suburbs
    "Rondebosch", "Claremont", "Kenilworth", "Wynberg", "Newlands", "Constantia", "Bishopscourt", "Tokai", "Bergvliet",
    "Plumstead", "Mowbray", "Rosebank", "Observatory", "Pinelands", "Thornton", "Ottery", "Lansdowne", "Athlone",
    // Cape Town - Northern Suburbs
    "Durbanville", "Bellville", "Parow", "Goodwood", "Kraaifontein", "Kuils River", "Brackenfell", "Plattekloof", "Loevenstein",
    "Welgemoed", "Eversdal", "Kenridge", "Panorama", "Monte Vista", "Edgemead", "Bothasig", "Table View", "Bloubergstrand",
    "Parklands", "Sunningdale", "Milnerton", "Royal Ascot", "Century City", "Melkbosstrand",
    // Cape Town - South Peninsula
    "Hout Bay", "Llandudno", "Noordhoek", "Fish Hoek", "Simon's Town", "Kommetjie", "Scarborough", "Muizenberg", "Lakeside", "Kalk Bay",
    // Cape Town - Helderberg
    "Somerset West", "Strand", "Gordon's Bay",
    // Winelands
    "Stellenbosch", "Paarl", "Wellington", "Franschhoek",
    // Johannesburg - Sandton & North
    "Sandton", "Bryanston", "Rivonia", "Morningside", "Fourways", "Douglasdale", "Lonehill", "Sunninghill", "Dainfern",
    "Paulshof", "Magaliessig", "Petervale", "Broadacres", "Witkoppen", "Beverley", "Craigavon",
    // Johannesburg - Randburg & North West
    "Randburg", "Northcliff", "Linden", "Blackheath", "Fairland", "Berario", "Blairgowrie", "Ferndale", "Bordeaux",
    "Robindale", "Fontainebleau", "Victory Park", "Greenside", "Parkhurst", "Parktown North", "Emmarentia", "Melville",
    // Johannesburg - City & Central
    "Parktown", "Houghton Estate", "Killarney", "Saxonwold", "Rosebank", "Hyde Park", "Dunkeld", "Inanda", "Illovo",
    // Johannesburg - East Rand
    "Bedfordview", "Edenvale", "Kempton Park", "Benoni", "Boksburg", "Brakpan", "Springs", "Nigel", "Alberton", "Germiston",
    // Johannesburg - South & West
    "Mondeor", "Winchester Hills", "Glenvista", "Mulbarton", "Meyersdal", "Roodepoort", "Krugersdorp", "Randfontein",
    // Midrand & Centurion
    "Midrand", "Kyalami", "Waterfall City", "Centurion", "Irene", "Rooihuiskraal", "Wierdapark", "Eldoraigne", "Zwartkop",
    // Pretoria
    "Pretoria East", "Moreleta Park", "Faerie Glen", "Garsfontein", "Lynnwood", "Menlo Park", "Brooklyn", "Waterkloof",
    "Hatfield", "Arcadia", "Silver Lakes", "Pretoria North", "Pretoria West", "Annlin", "Montana", "Wonderboom",
    // Durban & Coast
    "Umhlanga", "Umhlanga Rocks", "Mount Edgecombe", "La Lucia", "Durban North", "Glenashley", "Virginia", "Morningside (Durban)",
    "Berea", "Musgrave", "Glenwood", "Westville", "Pinetown", "New Germany", "Kloof", "Hillcrest", "Gillitts", "Waterfall (Durban)",
    "Amanzimtoti", "Kingsburgh", "Ballito", "Salt Rock", "Zimbali", "Stanger",
    // Other Major Cities
    "Bloemfontein", "Langenhoven Park", "Universitas", "George", "Knysna", "Plettenberg Bay", "Mossel Bay", "Hermanus",
    "Gqeberha (Port Elizabeth)", "Walmer", "Summerstrand", "Humewood", "East London", "Beacon Bay", "Nahoon", "Vincent",
    "Nelspruit (Mbombela)", "Polokwane", "Rustenburg", "Kimberley", "Pietermaritzburg", "Hilton", "Howick"
].sort();
